/**
 * Controls Caderninho/Notas in Carteira Contatos and Tabs.
 * Disabled by legal directive — set to `true` to re-enable.
 */
export const IS_WALLET_NOTES_ENABLED = false

export const assertWalletNotesEnabled = (): void => {
  if (!IS_WALLET_NOTES_ENABLED) {
    throw new Error('Wallet notes are disabled')
  }
}
